<template>
  <router-view v-if="auth"></router-view>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      auth: 'account/auth'
    })
  },
  watch: {
    auth () {
      this.loadAccountData()
    }
  },
  created () {
    this.loadAccountData()
  },
  methods: {
    loadAccountData () {
      this.$store.dispatch('account/load')

      if (this.auth) {
        this.$store.dispatch('tables/loadAll')
        this.$store.dispatch('bundles/loadAll')
        this.$store.dispatch('dossiers/loadAll')
        this.$store.dispatch('columnCategories/loadTree')
      }
    }
  }
}
</script>
